import { render, staticRenderFns } from "./FattorinoFilter.vue?vue&type=template&id=68a599c0&"
import script from "./FattorinoFilter.vue?vue&type=script&lang=ts&"
export * from "./FattorinoFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports